module.exports = __webpack_public_path__ + "img/Speaker=Sonia Edmonds.72b5332b.png";